import type { StudyQuantifierDB } from '../db';

export async function migrateToV1(_db: StudyQuantifierDB): Promise<void> {
  // v1 declares all stores in db.ts. This function exists as the anchor
  // point for future data-shape migrations beyond schema declaration.
}